import { Button, ButtonsGroup, Color, Link, Modal, Text, useModal } from '@billy/design-system'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useHideAccount } from '@features/accounts/hooks/useHideAccount'

import { useOrganizationViewUrl } from '../../../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../../../utils/routing/reactRoute'

interface HideAccountModalProps {
  accountId?: string
  id: string
}

export const HideAccountModal = ({ accountId, id }: HideAccountModalProps) => {
  const { t } = useTranslation()
  const { close } = useModal(id)
  const { url: chartOfAccountsUrl } = useOrganizationViewUrl(reactRoute.organization.chartOfAccounts.getMainRoute())
  const navigate = useNavigate()

  const { hideAccount, isProcessing } = useHideAccount({ accountId: accountId ?? '', modalId: id })

  const handleHideAccountLink = () => {
    navigate(chartOfAccountsUrl ?? '')
  }

  return (
    <Modal id={id} size="s">
      <Modal.Header title={t('bank.accounts.hide.title')} />
      <Modal.Body>
        <Text color={Color.Grey500}>
          <Trans
            i18nKey="bank.accounts.hide.description"
            components={{
              chartLink: <Link onClick={handleHideAccountLink} />,
            }}
          />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button variant="text" onClick={close}>
            {t('cancel')}
          </Button>
          <Button loading={isProcessing} onClick={() => hideAccount()}>
            {t('bank.accounts.hide.confirm')}
          </Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
